import _ from 'lodash';
import moment from 'moment';
import numeral from 'numeral';

import KendoChart from '../charts/KendoChart';
import KendoGrid from '../charts/KendoGrid';
import templates from '../templates';
import { destroyIntercom, openIntercom } from '../../../helpers/intercom.helper';

const infoBoard = () => require('../infoboard').default;
// const sidebar = () => require('../sidebar').default;

const databoard = (() => {
    let opened = false;
    const name = 'databoard';

    const reset = () => $(`#${name}-container`).empty();

    const createDashboard = (options, $template) => {
        const filename = [
            _.isObject(options.title) ? options.title.table : options.title,
            options.subtitle,
            ...(options.segmentsText || []),
            ...(options.companySizesText || []),
            options.startDate,
            options.endDate,
        ]
            .filter(v => v)
            .join(' - ');

        const nameFile = options.nameFile;

        const colors = [
            '#000080',
            '#00008B',
            '#0000CD',
            '#0000FF',
            '#6495ED',
            '#4169E1',
            '#2F4F4F',
            '#1E90FF',
            '#00BFFF',
            '#3CB371',
            '#2E8B57',
            '#006400',
            '#008000',
            '#228B22',
            '#32CD32',
            '#00FF00',
            '#00FA9A',
            '#00FF7F',
            '#98FB98',
            '#90EE90',
            '#8FBC8F',
            '#7CFC00',
            '#7FFF00',
            '#ADFF2F',
            '#9ACD32',
            '#6B8E23',
            '#556B2F',
            '#808000',
            '#00FFFF',
            '#00CED1',
            '#40E0D0',
            '#48D1CC',
            '#20B2AA',
            '#008B8B',
            '#008B8B',
            '#7FFFD4',
            '#66CDAA',
            '#5F9EA0',
            '#87CEFA',
            '#87CEEB',
            '#ADD8E6',
            '#4682B4',
            '#B0C4DE',
            '#708090',
            '#778899',
            '#FF8C00',
            '#FFA500',
            '#FFD700',
            '#FFFF00',
            '#F0E68C',
            '#7B68EE',
            '#9370DB',
            '#8A2BE2',
            '#4B0082',
            '#9400D3',
            '#9932CC',
            '#BA55D3',
            '#800080',
            '#8B008B',
            '#FF00FF',
            '#EE82EE',
            '#DA70D6',
            '#DDA0DD',
            '#C71585',
            '#FF1493',
            '#FF69B4',
            '#DB7093',
            '#FFB6C1',
            '#FFC0CB',
            '#F08080',
            '#CD5C5C',
            '#DC143C',
            '#FF4500',
            '#FA8072',
            '#E9967A',
            '#FFA07A',
            '#FF7F50',
            '#FF6347',
            '#800000',
            '#8B0000',
            '#B22222',
            '#A52A2A',
            '#FF0000'
        ];

        if (options.chart) {

            if (options.chartSplit || options.chartSplitEqual) {

                let colorsChart = _.cloneDeep(colors);

                if (!_.isUndefined(options.colorReverse) && options.colorReverse) {
                    colorsChart = _(colorsChart).reverse().map(f => f).value();
                }

                const chartColumn = {
                    container: $template.find('.databoard-chart'),
                    data: {
                        data: _.isArray(options.data) ? options.data[1] : options.data || options.dataSource,
                        type: 'column',
                        simple: true,
                        opacity: 0.75,
                        spacing: 0.10,
                        label: true,
                        gap: 0.25,
                        colors: _.map(
                            _.range(0, options.data[1].getTotalRows()),
                            i =>
                                (options.colors && options.colors[1] && options.colors[1][i % options.colors[1].length]) ||
                                colorsChart[i % colors.length]
                        ),
                        limit: options.limit ? options.limit : 9,
                        percent: _.isBoolean(options.percent) ? options.percent : false,
                        format: _.isArray(options.format) ? options.format[1] : options.format || null
                    },
                    options: {
                        title: _.isObject(options.title) ? options.title.chartColumn : 'Chart',
                        convertTable: _.isBoolean(options.convertTable) ? options.convertTable : true,
                        buttons: {
                            fullscreen: true
                        },
                        seriesClick: options.seriesClick,

                    }
                };
                (() => new KendoChart(chartColumn.container, chartColumn.data, chartColumn.options))();
            }
            else {
                const chart = {
                    container: $template.find('.databoard-chart'),
                    data: {
                        data: _.isArray(options.data) ? options.data[1] : options.data || options.dataSource,
                        type: 'column',
                        simple: true,
                        opacity: 0.75,
                        spacing: 0,
                        gap: 0.25,
                        colors: colors[0],
                        limit: options.limit ? options.limit : 9,
                        percent: _.isBoolean(options.percent) ? options.percent : false,
                        format: _.isArray(options.format) ? options.format[1] : options.format || null
                    },
                    options: {
                        convertTable: _.isBoolean(options.convertTable) ? options.convertTable : true,
                        buttons: {
                            export: true
                        }
                    }
                };

                (() => new KendoChart(chart.container, chart.data, chart.options))();
            }
        } else if (options.dash) {
            const formatLabelChartPie = ({ dataItem }) => {
                const { category, value } = dataItem;
                const val = value >= 1 ? value : numeral(value).format("0,0[.]0%");
                return `${category} - ${val}`;
            };

            const getDashType = (slot, fallback) => {
                if (options.dashTypes && options.dashTypes[slot]) {
                    return options.dashTypes[slot];
                }
                return fallback;
            };

            const getColorsForSlot = (slot, dataTable) => {
                return _.map(
                    _.range(0, dataTable.getTotalRows()),
                    i =>
                        (options.colors && options.colors[slot] && options.colors[slot][i % options.colors[slot].length]) ||
                        colors[i % colors.length]
                );
            };

            const chartPie = {
                container: $template.find('#databoard-dash-1'),
                data: {
                    colors: _.map(
                        _.range(0, options.data[1].getTotalRows()),
                        i =>
                            (options.colors && options.colors[1] && options.colors[1][i % options.colors[1].length]) ||
                            colors[i % colors.length]
                    ),

                    data: options.data[1],
                    type: 'pie',
                    simple: true,
                    opacity: 0.75,
                    percent: _.isBoolean(options.percent) ? options.percent : false,
                    format: _.isArray(options.format) ? options.format[1] : options.format || null,
                    limit: options.limit ? options.limit : 9,
                    legend: (_.isUndefined(options.legends) || _.isUndefined(options.legends.dash1)) ? {
                        visible: true,
                        position: 'right',
                        labels: {
                            font: `10px 'Roboto Condensed', sans-serif`,
                            template: formatLabelChartPie
                        },
                    } : options.legends.dash1,
                    tooltip: {
                        template: _.isUndefined(options.tooltip) || _.isUndefined(options.tooltip.pie) ? formatLabelChartPie : options.tooltip.pie
                    }
                },
                options: {
                    title: _.isObject(options.title) ? options.title.chartPie : 'Proporção',
                    convertTable: _.isBoolean(options.convertTable) ? options.convertTable : true,
                    buttons: {
                        fullscreen: true
                    }
                }
            };

            const chartColumn = {
                container: $template.find('#databoard-dash-2'),
                data: {
                    data: options.data[2],
                    type: 'column',
                    stacked: true,
                    simple: true,
                    singleTooltip: true,
                    opacity: 0.75,
                    spacing: 0.25,
                    gap: 0.25,
                    label: _.isUndefined(options.label) ? true : options.label,
                    limit: options.limit ? options.limit : 9,
                    colors: _.map(
                        _.range(0, options.data[2].getTotalRows()),
                        i =>
                            (options.colors && options.colors[1] && options.colors[1][i % options.colors[1].length]) ||
                            colors[i % colors.length]
                    ),
                    percent: _.isBoolean(options.percent) ? options.percent : false,
                    format: _.isArray(options.format) ? options.format[2] : options.format || null,
                    tooltip: !_.isUndefined(options.tooltip) && !_.isUndefined(options.tooltip.column)
                        ? { template: options.tooltip.column }
                        : null
                },
                options: {
                    title: _.isObject(options.title)
                        ? options.title.chartColumn
                        : `Histórico | ${moment(options.startDate, 'YYYYMM').format('MM/YYYY')} - ${moment(
                            options.endDate,
                            'YYYYMM'
                        ).format('MM/YYYY')}`,
                    convertTable: _.isBoolean(options.convertTable) ? options.convertTable : true,
                    margin: {
                        left: 10,
                        right: 10,
                        top: 10,
                        bottom: 5
                    },
                    buttons: {
                        fullscreen: true
                    }
                }
            };

            if (!_.isUndefined(options.data[3])) {

                const dash3Type = getDashType(3, 'pie');
                const dash3IsColumn = dash3Type === 'column';

                const chartPieSecond = {
                    container: $template.find('#databoard-dash-3'),
                    data: dash3IsColumn
                        ? {
                            data: options.data[3],
                            type: 'column',
                            stacked: true,
                            simple: true,
                            singleTooltip: true,
                            opacity: 0.75,
                            spacing: 0.25,
                            gap: 0.25,
                            label: _.isUndefined(options.label) ? true : options.label,
                            limit: options.limit ? options.limit : 9,
                            colors: getColorsForSlot(3, options.data[3]),
                            percent: _.isBoolean(options.percent) ? options.percent : false,
                            format: _.isArray(options.format) ? options.format[3] : options.format || null,
                            tooltip: !_.isUndefined(options.tooltip) && !_.isUndefined(options.tooltip.column)
                                ? { template: options.tooltip.column }
                                : null
                        }
                        : {
                            data: options.data[3],
                            type: 'pie',
                            simple: true,
                            opacity: 0.75,
                            percent: _.isBoolean(options.percent) ? options.percent : false,
                            format: _.isArray(options.format) ? options.format[1] : options.format || null,
                            limit: options.limit ? options.limit : 9,
                            legend: {
                                visible: true,
                                position: 'right',
                                labels: {
                                    font: `10px 'Roboto Condensed', sans-serif`,
                                    template: formatLabelChartPie
                                }
                            },
                            tooltip: {
                                template: formatLabelChartPie
                            }
                        },
                    options: {
                        title: _.isObject(options.title)
                            ? (dash3IsColumn
                                ? (options.title.chartColumnSecond || options.title.chartPieSecond || 'Chart')
                                : (options.title.chartPieSecond || 'Proporção'))
                            : 'Proporção',
                        convertTable: _.isBoolean(options.convertTable) ? options.convertTable : true,
                        buttons: {
                            fullscreen: true
                        }
                    }
                };
                (() => new KendoChart(chartPieSecond.container, chartPieSecond.data, chartPieSecond.options))();
            }

            if (!_.isUndefined(options.data[4])) {

                const thirdChartPie = {
                    container: $template.find('#databoard-dash-4'),
                    data: {
                        data: options.data[4],
                        type: 'pie',
                        simple: true,
                        opacity: 0.75,
                        percent: _.isBoolean(options.percent) ? options.percent : false,
                        format: _.isArray(options.format) ? options.format[1] : options.format || null,
                        limit: options.limit || 9,
                        legend: {
                            visible: true,
                            position: 'right',
                            labels: {
                                font: `10px 'Roboto Condensed', sans-serif`,
                                template: formatLabelChartPie
                            }
                        },
                        tooltip: {
                            template: formatLabelChartPie
                        }
                    },
                    options: {
                        title: options.title.chartPieThird,
                        convertTable: _.isBoolean(options.convertTable) ? options.convertTable : true,
                        buttons: {
                            fullscreen: true
                        }
                    }
                };

                (() => new KendoChart(thirdChartPie.container, thirdChartPie.data, thirdChartPie.options))();
            }

            (() => new KendoChart(chartPie.container, chartPie.data, chartPie.options))();
            (() => new KendoChart(chartColumn.container, chartColumn.data, chartColumn.options))();
        }

        const grid = {
            container: $template.find('.databoard-table'),
            data: _.isArray(options.data) ? options.data[0] : options.data || options.dataSource,
            options: {
                title: _.isObject(options.title)
                    ? options.title.table
                    : [options.title, options.subtitle].filter(v => v).join(' - '),
                filename: nameFile !== undefined ? nameFile : filename,
                exportHeader: options.exportHeader,
                group: options.group,
                sortable: options.sortable || false,
                filterable: options.filterable || false,
                columnMenu: options.columnMenu || false,
                autocoloring: !!options.colorize,
                colorize: options.colorize,
                // height: '100%',
                columns: options.columns,
                autoFitColumn: options.autoFitColumn || false,
                convertTable: _.isBoolean(options.convertTable) ? options.convertTable : true,
                buttons: (options.buttons == null || options.buttons == undefined) ? { export: true } : options.buttons,
                dataBound: options.dataBound
            }
        };

        setTimeout(() => new KendoGrid(grid.container, grid.data, grid.options), 500);
    };

    const createContainer = options => {
        const $template = $(templates('databoard-view-no-header', options));
        $template.appendTo(`#${name}-container`);

        if ((options.filters || {}).inputs) {
            options.filters.inputs = options.filters.inputs.filter(input => input.visible);

            const $tmpl = $(
                templates(`shared-inline-filters`, {
                    filters: options.filters
                })
            );

            $(`#${name}-container .action-bar`).append($tmpl);

            $('[name="databoard-filter-select"]').map((i, el) => {
                const id = $(el).data('id');
                const input = _.find(options.filters.inputs, f => String(f.id) === String(id));

                $(el).kendoDropDownList({
                    dataTextField: 'text',
                    dataValueField: 'value',
                    dataSource: input.values,
                    change: input.change,
                    index: input.index
                });
            });

            $('[name="databoard-filter-multiselect"]').map((i, el) => {
                const id = $(el).data('id');
                const input = _.find(options.filters.inputs, f => String(f.id) === String(id));

                $(el).kendoMultiSelect({
                    dataTextField: 'text',
                    dataValueField: 'value',
                    dataSource: input.values,
                    value: input.value,
                    change: input.change,
                    placeholder: input.placeholder
                });
            });

            $('#summary-submit').map((i, el) => {
                const id = $(el).data('id');
                const input = _.find(options.filters.inputs, f => String(f.id) === String(id));

                $(el).on('click', input.click);
            });
        }
        return $template;
    };

    // const hidePanels = () => {
    //     const displayWidth = Number($(window).width());
    //
    //     if (sidebar().isOpen()) {
    //         if (displayWidth <= 1440) {
    //             sidebar().close();
    //         }
    //     }
    //
    //     if (infoBoard().isOpen()) {
    //         if (displayWidth < 1280) {
    //             infoBoard().close();
    //         }
    //     }
    // };

    const show = options => {
        return new Promise((resolve, reject) => {
            reset();

            infoBoard().toggleDataboard(true, options.size || numeral(280 / window.innerHeight).format('0%'));
            createDashboard(options, createContainer(options));

            const verticalMessenger = options.size
                ? Number(options.size.replace('%', '')) + 450
                : 335;

            opened = true;

            setTimeout(() => openIntercom(window.intercomSettings.horizontal_padding, verticalMessenger), 100);

            resolve(true);
        });
    };

    const hide = () => {
        opened = false;
        infoBoard().toggleDataboard(false, 0);
    };

    const setOpen = show => {
        opened = show;
    };

    const isOpen = () => opened;

    return {
        hide,
        reset,
        show,
        isOpen,
        setOpen,
    };
})();

export default databoard;



// WEBPACK FOOTER //
// ./src/scripts/core/databoard/index.js